import baseApi from '../api/baseApi';

/************************************************** API **************************************************/
const expenseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseCategories: builder.query({
      query: () => ({
        url: 'expenses/categories',
        method: 'GET'
      }),
      transformResponse: (response) => response.data
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetExpenseCategoriesQuery } = expenseApi;
